import { render, staticRenderFns } from "./TableSortableHeader.vue?vue&type=template&id=572ba062&scoped=true&"
import script from "./TableSortableHeader.vue?vue&type=script&lang=js&"
export * from "./TableSortableHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableSortableHeader.vue?vue&type=style&index=0&id=572ba062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ba062",
  null
  
)

export default component.exports